/**
 * Define local data property `tableInDefaultPosition`, which has default value true.
 * Then declare a method to handle table scroll animation.
 *
 */

export default {
  data() {
    return {
      // this property can be used in template for conditional rendering
      tableInDefaultPosition: true,
    };
  },
  // table scroll event handler
  methods: {
    handleTableScroll: function(targetElement) {
      let scrollAmount = 0;
      const slideTimer = setInterval(() => {
        if (this.tableInDefaultPosition) {
          targetElement.scrollLeft -= 10;
        } else {
          targetElement.scrollLeft += 10;
        }
        scrollAmount += 10;
        if (scrollAmount >= 800) {
          window.clearInterval(slideTimer);
        }
      }, 1);
      this.togglePositionStatus();
    },
    togglePositionStatus: function() {
      this.tableInDefaultPosition = !this.tableInDefaultPosition;
    },
  },
};
